import { Decimal } from 'decimal.js';
import { formatDollarAmount, formatDollarAmountWithCents } from '../../../../../utils/number-formatting';
const isRange = (value)=>typeof value === 'object' && value !== null && value.to instanceof Decimal;
const isDiscounted = (value)=>typeof value === 'object' && value !== null && 'charged' in value && 'beforeDiscount' in value;
const amountText = (value, param)=>{
    let { openRangeText, alwaysShowCents } = param;
    // WHY: the whole-dollar arm goes when SALES_TAX merges — formatDollarAmountWithCents becomes the only money format.
    const format = alwaysShowCents ? formatDollarAmountWithCents : formatDollarAmount;
    if (value instanceof Decimal) return format(value);
    if (!isRange(value)) return undefined;
    const max = format(value.to);
    if (value.from != null) return "".concat(format(value.from), " - ").concat(max);
    return openRangeText == null ? max : openRangeText(max);
};
export const moneyParts = function moneyParts(value) {
    let options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (isDiscounted(value)) {
        const charged = amountText(value.charged, options);
        const beforeDiscount = amountText(value.beforeDiscount, options);
        return charged == null ? undefined : {
            charged,
            beforeDiscount
        };
    }
    const charged = amountText(value, options);
    return charged == null ? undefined : {
        charged
    };
};
